import Input from '@mui/material/Input';
import { SearchBarProps } from '../types';

const SearchBar = ({ value, onChange, onClear }: SearchBarProps) => {
	return (
		<div className="relative w-full">
			<Input
				value={value}
				className="pl-10 w-full bg-white border border-gray-300 rounded-full py-2"
				placeholder="Search templates..."
				onChange={(e) => onChange(e.target.value)}
				disableUnderline={true}
				inputProps={{
					style: {
						border: 'none',
						outline: 'none',
						boxShadow: 'none',
					},
				}}
				sx={{
					'&:before': { display: 'none' },
					'&:after': { display: 'none' },
					'&:hover:not(.Mui-disabled):before': { display: 'none' },
				}}
			/>
			<svg
				className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
				fill="none"
				stroke="currentColor"
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth={2}
					d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
				/>
			</svg>
			{value && (
				<div className="absolute right-3 top-1/2 -translate-y-1/2">
					<button onClick={onClear} className="text-gray-400 hover:text-gray-600 transition-colors">
						<svg
							className="w-5 h-5"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M6 18L18 6M6 6l12 12"
							/>
						</svg>
					</button>
				</div>
			)}
		</div>
	);
};

export default SearchBar;
